/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {ContactId, ContactInput} from "../__ignore/schemas";

/**
 * @summary Edit client contact
 */
export const EditClientContactBody = ContactInput;

export const EditClientContactResponse = zod.void();

/**
 * @summary Remove client contact
 */
export const RemoveClientContactResponse = zod.void();

/**
 * @summary Add client contact
 */
export const AddClientContactBody = ContactInput;

export const AddClientContactResponse = ContactId;
